


















import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "good-bye-component",
})
export default class GoodByeComponent extends Vue {
  mounted() {
    localStorage.clear();
  }
  isHawkings(): boolean {
    if (window.location.host.includes("hawkings.education")) return true;
    else return false;
  }
  get web() {
    return process.env.VUE_APP_WEB;
  }
}
